import { useEffect, useState } from "react";
import { currentPushStatus, notificationPermission, requestNotificationPermission, type PushStatus } from "../push/webPush";

interface Props {
  audioEnabled: boolean;
  onEnableAudio: () => void;
}

// Onboarding-/Setup-Bereich: Audio-Freigabe, Notification-Permission,
// Web-Push-Status. Ehrliche Statusaussagen, kein Fake-Push.
export function SetupPanel({ audioEnabled, onEnableAudio }: Props) {
  const [perm, setPerm] = useState(notificationPermission());
  const [push, setPush] = useState<PushStatus>(currentPushStatus());

  useEffect(() => {
    setPush(currentPushStatus());
  }, [perm]);

  const pushLabel: Record<PushStatus, string> = {
    not_supported: "Vom Browser nicht unterstützt",
    not_configured: "Noch nicht konfiguriert (VAPID fehlt)",
    permission_denied: "Benachrichtigungen blockiert",
    permission_default: "Berechtigung noch nicht erteilt",
    subscription_active: "Aktiv",
    subscription_error: "Fehler beim Einrichten",
  };

  return (
    <section className="setup" aria-label="Terminal-Einrichtung">
      <h2>Terminal-Einrichtung</h2>
      <div className="setup__row">
        <div>
          <div className="setup__title">Alarmton</div>
          <div className="setup__desc">{audioEnabled ? "Ton ist aktiviert." : "Ton ist noch nicht aktiviert. Einmal aktivieren, damit der Alarm hörbar ist."}</div>
        </div>
        <button className="btn" onClick={onEnableAudio} disabled={audioEnabled}>
          {audioEnabled ? "Aktiviert" : "Ton aktivieren"}
        </button>
      </div>

      <div className="setup__row">
        <div>
          <div className="setup__title">Systembenachrichtigungen</div>
          <div className="setup__desc">Status: {permLabel(perm)}</div>
        </div>
        <button
          className="btn"
          disabled={perm !== "default"}
          onClick={async () => setPerm(await requestNotificationPermission())}
        >
          {perm === "default" ? "Erlauben" : perm === "granted" ? "Erlaubt" : "Blockiert"}
        </button>
      </div>

      <div className="setup__row">
        <div>
          <div className="setup__title">Hintergrund-Push (Web Push)</div>
          <div className="setup__desc">Status: {pushLabel[push]}</div>
        </div>
        <span className={`badge ${push === "subscription_active" ? "badge--ok" : "badge--muted"}`}>{push}</span>
      </div>

      <p className="setup__note">
        Bei geöffnetem Terminal werden neue Bestellungen sofort per Live-Verbindung angezeigt und (bei aktiviertem Ton)
        akustisch gemeldet. Ein garantierter Hintergrund-Alarm bei geschlossener App ist erst mit konfiguriertem Web Push
        möglich.
      </p>
    </section>
  );
}

function permLabel(p: string): string {
  return p === "granted" ? "Erlaubt" : p === "denied" ? "Blockiert" : p === "unsupported" ? "Nicht unterstützt" : "Noch nicht entschieden";
}
